import loop from 'raf-loop';
// import * as PIXI from 'pixi.js';
import { TweenLite } from 'gsap';

let basicPhase = 0.75

export default class PIXIRender {
  constructor(canvas, data, callback) {
    this.canvas = canvas;
    this.isEnter = false;

    import(/* webpackChunkName: "pixi" */ 'pixi.js').then((pixi) => {
      this.PIXI = pixi;
      this.PIXI.utils.skipHello();

      this.PIXI.utils.skipHello();

      this.renderer = this.PIXI.autoDetectRenderer({
        view: canvas,
        transparent: true,
        antialias: true,
      });

      this.stage = new this.PIXI.Container();
      this.textures = [];

      this.loadTextures(data);

      this.phase = basicPhase;

      this.paused = true;
      this.loopStarted = false;

      this.uniforms = {
        video: this.textures[0],
        time: 0,
        phase: basicPhase,
        aspectRatio: 1,
      }

      const vs = require('./shaders/main.vert');
      const fs = require('./shaders/main.frag');

      this.isEnter = true;
      this.generateShader(vs, fs);
      this.setTexture(0);

      document.addEventListener('resize', this.resize.bind(this));

      callback();
    });
  }

  reset() {
    if (this.tween) {
      TweenLite.killTweensOf(this.tween);
      TweenLite.killTweensOf(this.canvastween);
    }

    this.phase = basicPhase;
    TweenLite.set(this.canvas, { autoAlpha: 1 });
  }

  phaseOut(timing) {
    if (this.tween) {

      TweenLite.killTweensOf(this.tween);
      TweenLite.killTweensOf(this.canvastween);
    }

    this.start();

    this.tween = TweenLite.to(this, timing, { phase: -0.2 });
    this.canvastween = TweenLite.to(this.canvas, timing, {
      autoAlpha: 0,
      onComplete: () => {
        this.stop();
      },
    });
  }

  phaseIn(timing, force, delay = 0) {
    if (this.tween) {
      TweenLite.killTweensOf(this.tween);
      TweenLite.killTweensOf(this.canvastween);
    }

    if (force) {
      this.phase = 0;
      TweenLite.set(this.canvas, { autoAlpha: 0 });
    }

    this.start();

    this.tween = TweenLite.to(this, timing, {
      phase: basicPhase,
      delay: delay,
    });
    this.canvastween = TweenLite.to(this.canvas, timing, {
      autoAlpha: 1,
      delay: delay,
    });
  }

  start(force = false) {
    this.loopStarted = true;

    if (this.paused == true) {
      if (this.tween) {
        this.tween.kill();
        this.canvastween.kill();
      }

      this.loop = loop(this.renderEvent = this.update.bind(this));
      this.loop.start();

      this.paused = false;
    }
  }

  stop() {
    this.loopStarted = false;
    if (this.paused == false) {
      this.loop.stop();

      this.paused = true;
    }
  }

  update() {
    this.uniforms.phase = this.phase;

    this.uniforms.time += 0.032;

    this.renderer.render(this.stage);
  }

  setTexture(index) {
    if (!this.isEnter) return;
    this.resize();

    this.shader.uniforms.video = this.textures[index];
  }

  loadTextures(data) {
    // let i = 0;
    // while(i < data.length) {
    //   let texture = new this.PIXI.Texture.fromImage(this.coverUrl(data[i].cover));

    //   this.textures.push(texture);

    //   i++
    // }
    const texture = new this.PIXI.Texture.fromImage(this.coverUrl(data));

    this.textures.push(texture);
  }

  generateShader(vs, fs) {
    const indices = [
      0, 1, 2,
      0, 2, 3
    ];

    let positions = [];
    positions = positions.concat([-1, 1, 0]);
    positions = positions.concat([1, 1, 0]);
    positions = positions.concat([1, -1, 0]);
    positions = positions.concat([-1, -1, 0]);

    const geometry = new this.PIXI.mesh.Geometry();

    geometry.addAttribute('positions', positions, 3);
    geometry.addAttribute('aUV', [0, 0, 1, 0, 1, 1, 0, 1], 2);
    geometry.addIndex(indices);

    this.shader = new this.PIXI.Shader.from(vs, fs, this.uniforms);
    this.mesh = new this.PIXI.mesh.RawMesh(geometry, this.shader);

    this.stage.addChild(this.mesh);
  }

  coverUrl(cover) {
    return cover;
  }

  resize() {
    if (this.canvas.parentElement && this.isEnter) {
      const w = this.canvas.parentElement.clientWidth;
      const h = this.canvas.parentElement.clientHeight;

      this.renderer.resize(w, h);

      this.mesh.shader.uniforms.aspectRatio = w / h;
    }
  }

  destroy() {
    if (this.loopStarted) this.loop.stop();
    document.removeEventListener('resize', this.resize);
  }
}


// WEBPACK FOOTER //
// ./src/assets/lib/video/pixirenderer.js